import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Accordion } from '@folio/stripes/components';
import DefaultLibraryEditFields from './DefaultLibraryEditFields';

const DefaultLibraryEditInfo = ({ accordionId, expanded, onToggle, libraries, disabled }) => {
  return (
    <Accordion
      id={accordionId}
      label={<FormattedMessage id="ui-users.defaultLibrary.section.title" />}
      open={expanded}
      onToggle={onToggle}
    >
      <DefaultLibraryEditFields libraries={libraries} disabled={disabled} />
    </Accordion>
  );
};

DefaultLibraryEditInfo.propTypes = {
  accordionId: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  libraries: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
};

DefaultLibraryEditInfo.defaultProps = {
  libraries: [],
  disabled: false,
};

export default DefaultLibraryEditInfo;